import { supabase } from './supabase'
import { MESSAGE_COMPTE_EXISTANT, adresseDejaInscrite, traduireErreurInscription } from './compte'

/**
 * Crée un compte e-mail + mot de passe. N'écrit AUCUNE ligne (rôle, profil,
 * équipe) : les droits sont accordés ensuite par un administrateur.
 * `sessionOuverte` = faux quand la confirmation par e-mail est active.
 */
export async function creerCompte(
  nom: string,
  email: string,
  motDePasse: string,
): Promise<{ sessionOuverte: boolean }> {
  const { data, error } = await supabase.auth.signUp({
    email,
    password: motDePasse,
    options: {
      data: { full_name: nom },
      emailRedirectTo: window.location.origin + window.location.pathname,
    },
  })
  if (error) throw new Error(traduireErreurInscription(error.message, error.code, error.status))
  if (adresseDejaInscrite(data.user)) throw new Error(MESSAGE_COMPTE_EXISTANT)
  return { sessionOuverte: !!data.session }
}
